export const TIPS: { [x: string]: string } = {
  SAVE_INFO: 'Никто, кроме вас не сможет изменить маршрут - только создать его копию и сохранить по другому адресу',
  SAVE_TIMED_OUT: 'Сервер не ответил на запрос, попробуйте еще раз',
  SAVE_EMPTY: 'Этот маршрут пуст, нарисуйте что-нибудь для начала',
  SAVE_SUCCESS: 'Отлично! Ваш маршрут сохранён. Поделитесь ссылкой с друзьями, приятной покатушки!',
  SAVE_OVERWRITE: 'У вас уже есть маршрут с таким именем. Можно перезаписать его или переименовать?',
  SAVE_EXISTS: 'Маршрут с таким адресом уже есть. Придумайте что-нибудь другое.'
};
